<!--人文美育-视频库管理-->
<template>
    <div class="v-studio_nav_content" >
        <el-scrollbar class="v-page-mode" v-loading="loading">
            <div class="head-container" style="margin-bottom: 5px">
                <div class="v-left-head-container" @click="backPage">
                    <el-affix :offset="90">
                        <svg t="1766639305795" @click="backPage" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#ff7f2e" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
                    </el-affix>
                </div>
                <div class="v-right-head-container">{{this.moduleName}}</div>
                <div class="v-left-head-container" >
                    <el-affix :offset="90">
                        <el-dropdown>
                            <div class="theme-btn">跳转主题</div>
                            <template #dropdown>
                                <el-dropdown-menu>
                                    <el-dropdown-item v-for="v in videoList" @click.stop="goToItem('museumItem'+v.itemNo)">{{v.itemName}}</el-dropdown-item>
                                </el-dropdown-menu>
                            </template>
                        </el-dropdown>
                    </el-affix>

                </div>
            </div>

            <div class="v-container" v-for="item in videoList" >
                <div class="museum-item-title-container" :id="'museumItem'+item.itemNo">
                    <div class="museum-item-title-l">
                        <svg t="1773214332902" class="icon"  viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2425" width="24" height="24"><path d="M79.084173 949.307857l362.873588 0L441.957761 586.442456 79.084173 586.442456 79.084173 949.307857zM79.084173 465.487663l362.873588 0L441.957761 102.622262 79.084173 102.622262 79.084173 465.487663zM562.904367 949.307857l362.873588 0L925.777955 586.442456 562.904367 586.442456 562.904367 949.307857zM1000.923422 284.054451 744.344742 27.468608 487.758899 284.054451l256.585843 256.585843L1000.923422 284.054451z" fill="#ff7f2e" p-id="2426"></path></svg>
                    </div>
                    <div class="museum-item-title-r">{{item.itemName}}</div>

                </div>

                <div class="video-container">
                    <div class="video-box" >
                        <div class="video-item" v-for="video in item.videoList">
                            <div class="item-p1">
                                <div class="video-cover">
                                    <img alt="" :src="video.coverUrl" class="img-100">
                                </div>
                                <div class="video-name">
                                    {{video.title}}
                                </div>
                            </div>
                            <div class="item-p2">
                                <div class="player-container">
                                    <div class="player-container">
                                        <img alt="" @click="viewVideo(video)" class="img-100"
                                             src="../../../assets/icon/img/player.png">
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="div-100" v-if="item.videoList&&item.videoList.length===0">
                            <dataEmpty title="暂无视频" />
                        </div>

                    </div>
                </div>
            </div>
        </el-scrollbar>
    </div>

    <el-dialog class="ar-dialog" :title="videoName" v-model="isViewVideoShow"
               top="8vh"
               width="830px" @close="destroyed">
        <div id="player"></div>
    </el-dialog>
</template>

<script>
import {serviceUrl} from "@/utils/global";
import {listHumanityVideo,listSeriesNames} from "@/api/admin/humanityCourse"
import dataEmpty from "@/components/dataEmpty.vue";

export default {
    name: "beautyVideos",
    components: {dataEmpty},
    data() {
        return {
            serviceUrl,
            videoList:[],
            allVideoList:[],
            nameList:[],
            courseName:'',
            mk:'0',
            isViewVideoShow:false,
            loading:false,
            vodPlayerJs: 'https://player.polyv.net/resp/vod-player/latest/player.js',
            vid:'',
            videoName:'',
            videoWidth:800,
            videoHeight:500,
            itemId:'',

        }
    },
    computed: {},
    props:{
        moduleKey:{
            type: String,
            default:null
        },
        moduleName:{
            type: String,
            default:null
        },
        markInfo:{
            type: String,
            default:null
        },
    },
    watch: {
        moduleKey(newValue,oldValue){

        },
        moduleName(newValue,oldValue){
        },
        markInfo(newValue,oldValue){
            this.queryVideoList();
        },
    },
    created() {
    },
    mounted(){
    },
    methods: {
        changeModel(item){
            this.showMode = item
            this.$emit('change-mode',this.showMode, 8);
        },
        backPage(){
            this.mk = '0';
            this.$emit('back-model-page', 'beautyEdu');
        },
        queryVideoList(){
            this.loading = true;
            this.itemId=""
            this.videoList = [];
            listHumanityVideo({ moduleKey: this.moduleKey }).then(res => {
                if (res.data.code === 1) {
                    this.videoList = res.data.data;
                    this.allVideoList = res.data.data;
                    this.loading = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading = false;
                }
            })
        },
        viewVideo(row){
            this.vid = row.videoId;
            this.videoName = row.title;
            this.isViewVideoShow = true;
            setTimeout(() => {
                this.loadPlayerScript(this.loadPlayer);
            })
        },
        loadPlayerScript(callback) {
            if (!window.polyvPlayer) {
                const myScript = document.createElement('script');
                myScript.setAttribute('src', this.vodPlayerJs);
                myScript.onload = callback;
                document.body.appendChild(myScript);
            } else {
                callback();
            }
        },
        loadPlayer() {
            const polyvPlayer = window.polyvPlayer;
            this.player = polyvPlayer({
                wrap: '#player',
                width: this.videoWidth,
                height: this.videoHeight,
                vid: this.vid,
            });
        },
        destroyed() {
            if (this.player) {
                this.player.destroy();
            }
            this.isViewVideoShow = false;
        },
        filterVideo(){
            this.videoList = this.allVideoList;
            if (this.courseName){
                this.videoList = this.videoList.filter((item)=>{
                    return item.courseName.includes(this.courseName)
                })
            }
        },
        goToItem(id){
            debugger
            const targetElement = document.querySelector('#'+id); // 获取目标元素
            if (targetElement) {
                targetElement.scrollIntoView(
                  { block: 'start', behavior: 'smooth' },
                ); // 平滑滚动到目标元素
            }
        },
    }
}

</script>

<style scoped>
.v-studio_nav_content{
    width: 100%;
    height: calc(100vh - 90px);
}
.v-page-mode{
    width: 100%;
    height: calc(100vh - 90px);
    //height: auto;
    background-color: #fff;
    padding-bottom: 10px;
    box-sizing: border-box;
}
.head-container{
    width: 100%;
    height: 44px;
    display: flex;
}
.v-left-head-container{
    width: 100px;
    height: 44px;
    cursor: pointer;
    padding-left: 10px;
    padding-top: 9px;
}
.v-right-head-container{
    width: calc(100% - 200px);
    height: 44px;
    text-align: center;
    font-size: 18px;
    color: #ff7f2e;
    line-height: 44px;
    font-weight: bold;
}
.theme-btn{
    width: 80px;
    height: 28px;
    background-color: #ff7f2e;
    color: #fff;
    border-radius: 5px;
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-weight: bold;
}
.museum-item-title-container{
    width: 100%;
    height: 40px;
    display: flex;
}
.museum-item-title-l{
    width: 34px;
    height: 40px;
    padding-top: 8px;
    padding-left: 5px;
    box-sizing: border-box;
}
.museum-item-title-r{
    width: calc(100 - 34px);
    height: 40px;
    text-align: left;
    font-size: 16px;
    color: #ff7f2e;
    line-height: 40px;
    font-weight: bold;
}
.v-container{
    width: 100%;
    height: auto;
}

.video-container{
    width: 100%;
    height: auto;
    display: flex;
    flex-wrap: wrap!important;
}

.video-item{
    width: 320px;
    height: 220px;
    padding: 0 5px 0 5px;
    box-sizing: border-box;
    cursor: pointer;
}
.item-p1{
    width: 100%;
    height: 100%;
    //position: relative;
    z-index: 1;
}
.item-p2{
    width: 100%;
    height: 100%;
    z-index: 2;
    margin-top: -200px;
    padding-top: 50px;
    box-sizing: border-box;
}
.player-container{
    width: 40px;
    height: 40px;
    margin: auto;
}
.video-cover{
    width: 100%;
    height: 180px;
}
.video-name{
    width: 100%;
    height: 40px;
    line-height: 16px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    color: #b1b1b1;
    padding-top: 5px;
}
</style>